document.addEventListener('DOMContentLoaded', () => {
  const initials = document.querySelectorAll('[data-testimonial-initial]');

  initials.forEach((node, index) => {
    const hue = Math.floor((Math.random() * 360 + index * 37) % 360);
    const color = `hsl(${hue}, 65%, 55%)`;
    node.style.setProperty('--avatar-color', color);
  });

  const reviewDates = document.querySelectorAll('[data-review-date]');
  const now = new Date();

  reviewDates.forEach((el) => {
    const dateStr = el.getAttribute('data-review-date');
    const parsed = new Date(dateStr);
    if (isNaN(parsed.getTime())) {
      return;
    }

    const months = monthDiff(parsed, now);
    let label;

    if (months <= 0) {
      label = 'Este mes';
    } else if (months >= 12) {
      const years = Math.floor(months / 12);
      const remainingMonths = months % 12;
      if (remainingMonths === 0) {
        label = `hace ${years} años`;
      } else {
        label = `hace ${years} años y ${remainingMonths} meses`;
      }
    } else {
      label = `hace ${months} meses`;
    }

    el.textContent = label;
  });
});

function monthDiff(from, to) {
  const years = to.getFullYear() - from.getFullYear();
  const months = to.getMonth() - from.getMonth();
  let diff = years * 12 + months;

  if (to.getDate() < from.getDate()) {
    diff -= 1;
  }

  return Math.max(diff, 0);
}
